var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"upload-image-button"},[_c('LoadingButton',{attrs:{"loading":_vm.uploading}},[_vm._t("default")],2),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"image/png, image/jpeg, image/svg+xml"},on:{"change":_vm.changedFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }